<template>
  <g>
    <!-- fiber -->
    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2)" 
          :height="fiberHeight" 
          :x="svgPadding" 
          :y="(svgHeight / 2)" 
          style="fill: gold; stroke-width: 1; stroke: rgb(223,168,39);" />
    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2)" 
          :height="fiberHeight" 
          :x="(svgWidth / 2)" 
          :y="(svgHeight / 2)" 
          style="fill: gold; stroke-width: 1; stroke: rgb(223,168,39);"
          v-if="!isPigtail"/>

    <!-- cladding -->
    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2) - svgCladdingMargin" 
          :height="claddingHeight" :x="(svgPadding + svgCladdingMargin)" 
          :y="(svgHeight/2 - claddingHeight / 2)" 
          style="fill: #ccbe82; stroke-width: 1; stroke: #ccbe82" />

    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2) - svgCladdingMargin" 
          :height="claddingHeight" 
          :x="(svgWidth / 2)" 
          :y="(svgHeight / 2 - claddingHeight / 2)" 
          style="fill: #ccbe82; stroke-width: 1; stroke: #ccbe82" 
          v-if="!isPigtail"/>

    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2)" 
          :height="claddingHeight" 
          :x="(svgWidth / 2)" 
          :y="(svgHeight / 2 - claddingHeight / 2)" 
          style="fill: #ccbe82; stroke-width: 1; stroke: #ccbe82" 
          v-if="isPigtail"/>

    <!-- cloak -->
    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2) - svgCladdingMargin - (svgCloakMargin) + 5" 
          :height="cloakHeight" 
          :x="(svgPadding + svgCladdingMargin + svgCloakMargin)" 
          :y="(svgHeight / 2 - cloakHeight / 2)" 
          :style="cloakStyle" />

    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2) - svgCladdingMargin - (svgCloakMargin)" 
          :height="cloakHeight" 
          :x="(svgWidth / 2)" 
          :y="(svgHeight / 2 - cloakHeight / 2)" 
          :style="cloakStyle" 
          v-if="!isPigtail"/>

    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2) - 5" 
        :height="cloakHeight" 
        :x="(svgWidth / 2)" 
        :y="(svgHeight / 2 - cloakHeight / 2)" 
        :style="cloakStyle" 
        v-if="isPigtail"/>

    <!-- reflection -->
    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2) - svgCladdingMargin - (svgCloakMargin) + 5" 
          :height="1" 
          :x="(svgPadding + svgCladdingMargin + svgCloakMargin)" 
          :y="(svgHeight / 2 - 2)" 
          style="fill: white;" />

    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2) - svgCladdingMargin - (svgCloakMargin)" 
          :height="1" 
          :x="(svgWidth / 2)" 
          :y="(svgHeight / 2 - 2)" 
          style="fill: white;" 
          v-if="!isPigtail"/>

    <rect :width="(svgWidth - svgPadding) - (svgWidth / 2) - 5" 
          :height="1" 
          :x="(svgWidth / 2)" 
          :y="(svgHeight / 2 - 2)" 
          style="fill: white;" 
          v-if="isPigtail"/>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      fiberHeight: 1,
      claddingHeight: 6,
      cloakHeight: 8
    }
  },
  props: {
    svgHeight: Number,
    svgWidth: {
      type: Number,
    },
    svgPadding: {
      type: Number,
      default: 20
    },
    svgCladdingMargin: {
      type: Number,
      default: 30
    },
    svgCloakMargin: {
      type: Number,
      default: 35
    },
    cableColor: String,
    isPigtail: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),

    // cloak color based on cable color selection
    cloakStyle: function () {
      let color = this.getCssColor(this.cableColor)
      return `fill: ${color}; stroke-width: 1; stroke: ${color};`
    },
  }
}
</script>